// 珀莱雅小程序版本
import Overview from './overview.vue';
import StandardOverview from '@rebuild/materials/shared/quote/standard/FlowOverview.vue';
import { isWxMiniProgram } from '@/utils/const';
import { getUrlParam } from '@/utils/api';

const __channel = getUrlParam().comein_channel;
const inBlyMiniProgram = !!__channel && isWxMiniProgram;
const shouldUseStandard = !inBlyMiniProgram;

export const componentMap = {
	overview: shouldUseStandard ? StandardOverview : Overview
};
